// Datos de muestra para la maqueta del Lector de Temas.
// Fieles al prototipo aprobado (preview_lector_temas.html) pero con el
// esquema estructurado que la automatización guardará en RTDB
// (vortex_lector_temas/{jerarquia}/{cuerpo}/{especialidad}/{temaId}).

export const LECTOR_SAMPLE = [
  {
    id: 'l_101',
    title: 'Lección 1: Ley de Disciplina y Uso de la Fuerza',
    module: 'Módulo 1',
    completed: true,
    paragraphs: [
      'La aplicación del Artículo 15 en misiones de seguridad marítima exige al personal naval actuar bajo principios de legalidad, necesidad y proporcionalidad en todo momento, sin distinción de rango o zona de operación.',
      'Toda intervención que implique el uso de la fuerza debe documentarse de inmediato, iniciando la cadena de custodia para salvaguardar la validez legal de los elementos probatorios ante las autoridades jurisdiccionales.',
    ],
    bullets: [
      'Principio de proporcionalidad: la fuerza utilizada debe ser acorde a la amenaza.',
      'Documentación obligatoria: acta de aseguramiento y registro de cadena de custodia.',
      'Responsabilidad del Comandante de Unidad en intervenciones jurisdiccionales.',
    ],
    callout: {
      type: 'info',
      icon: 'ℹ️',
      text: 'En operaciones de interdicción, la evaluación de la amenaza se realiza en segundos; el criterio legal previo es la única defensa válida del actuante.',
    },
    interactive: true,
    kps: [
      { t: '¿Qué es proporcionalidad?', b: 'Relación equilibrada entre la medida de fuerza y la amenaza enfrentada, evaluada por un mando responsable.' },
      { t: '¿Cuándo inicia la cadena de custodia?', b: 'En el momento exacto del aseguramiento, con la elaboración del acta y el registro fotográfico inicial.' },
    ],
    quizQuestions: [
      {
        question: 'Según el Artículo 15, ¿cuándo se considera legítimo el uso de la fuerza?',
        options: [
          'Cuando es proporcional a la amenaza y dentro del marco legal',
          'Solo bajo orden verbal directa del superior',
          'En cualquier operación sin restricciones',
          'Exclusivamente en defensa propia',
        ],
        correct_index: 0,
      },
    ],
  },
  {
    id: 'l_102',
    title: 'Lección 2: Deberes Navales y Jerarquía',
    module: 'Módulo 1',
    completed: true,
    paragraphs: [
      'El principio de subordinación constituye la columna vertebral del servicio naval. Todo ejercicio del mando debe ser responsable, oportuno y conforme al reglamento militar vigente.',
      'La transmisión de órdenes en situaciones tácticas complejas sigue un protocolo estandarizado para evitar ambigüedades que comprometan la misión o la seguridad del personal.',
    ],
    bullets: [
      'Cadena de mando y conducto regular para la transmisión de órdenes.',
      'Procedimientos de relevo y traspaso de responsabilidades.',
      'Conducta del personal ante órdenes contrarias al marco legal.',
    ],
    callout: {
      type: 'warn',
      icon: '⚠️',
      text: 'La obediencia debida tiene límites: ninguna orden puede contravenir la ley ni los derechos humanos fundamentales.',
    },
    interactive: true,
    kps: [
      { t: '¿Qué es el conducto regular?', b: 'La vía jerárquica establecida por la que deben fluir órdenes, informes y solicitudes.' },
    ],
    quizQuestions: [
      {
        question: '¿Qué vía se utiliza para transmitir una orden en situaciones tácticas complejas?',
        options: [
          'El conducto regular jerárquico establecido',
          'La comunicación directa entre cualquier rango sin protocolo',
          'Únicamente por medios informales',
          'El criterio de cada elemento en campo',
        ],
        correct_index: 0,
      },
    ],
  },
  {
    id: 'l_103',
    title: 'Lección 3: Jurisprudencia Castrense Aplicada',
    module: 'Módulo 2',
    completed: false,
    paragraphs: [
      'El análisis de jurisprudencia castrense permite anticipar criterios de resolución en casos de indisciplina y faltas al servicio, fortaleciendo la defensa legal del personal.',
      'Cada precedente judicial se integra al manual operativo de la unidad como referencia obligatoria para la toma de decisiones.',
    ],
    bullets: [
      'Precedentes relevantes en materia de disciplina naval.',
      'Criterios de la justicia militar frente a faltas administrativas.',
    ],
    callout: {
      type: 'info',
      icon: '📚',
      text: 'La jurisprudencia no sustituye la ley, pero orienta su interpretación en casos análogos.',
    },
    interactive: false,
    kps: [],
    quizQuestions: [],
  },
  {
    id: 'l_104',
    title: 'Lección 4: Evaluación del Módulo',
    module: 'Módulo 2',
    completed: false,
    isQuiz: true,
    paragraphs: ['Repaso interactivo de los temas del módulo. Completa el quiz para avanzar al siguiente módulo.'],
    bullets: [],
    callout: null,
    interactive: true,
    kps: [],
    quizQuestions: [
      {
        question: '¿Cuál es el principio fundamental que rige el uso legítimo de la fuerza?',
        options: [
          'Proporcionalidad, legalidad y necesidad absoluta',
          'Discrecionalidad total del jefe de operativo',
          'Exclusivamente mandato judicial previo de 48 horas',
          'Aprobación verbal por radio en cada maniobra',
        ],
        correct_index: 0,
      },
      {
        question: '¿Qué documento debe elaborarse al realizar un aseguramiento en zona costera?',
        options: [
          'Registro de Cadena de Custodia y Acta de Aseguramiento',
          'Únicamente el parte diario meteorológico',
          'Notificación informal al supervisor de turno',
          'Ningún documento hasta arribar a puerto base',
        ],
      },
    ],
  },
];
